import ContainerFull from './ContainerFull'
import ContainerDefault from './ContainerDefault'

export default {
  ContainerFull,
  ContainerDefault
}



// WEBPACK FOOTER //
// ./src/components/containers/index.js